<template>
  <v-data-table
    :headers="headers"
    :items="issues"
    sort-by="model"
    class="elevation-1 issues"
    hide-default-footer
  >
    <template v-slot:top>
      <v-toolbar
        flat
        color="accent"
      >
        <v-toolbar-title class="white--text">Issues</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
          scrollable
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              tile
              small
            >
              <v-icon dark>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="primary">
              <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text class="pa-0">
              <v-tabs
              v-model="tabjob"
              background-color="accent"
              centered
              dark
              icons-and-text
              tile
              >
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab href="#tab-1">
                      Issue Data
                      <v-icon>mdi-format-list-bulleted-square</v-icon>
                  </v-tab>
                  <v-tab href="#tab-2">
                      Notes/Comments
                      <v-icon>mdi-clipboard-list</v-icon>
                  </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tabjob">
                  <v-tab-item
                      value="tab-1"
                  >
                    <v-card>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedItem.issue"
                                label="Issue"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions class="grey lighten-3">
                        <v-btn
                          large min-width="49%" color="blue darken-1" text
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          large min-width="49%" color="primary" tile
                          @click="save"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item
                      value="tab-2"
                  >
                    <Comment v-for="(comment, index) in editedItem.comments" :key="index" :item="comment" @set-parent="replyComment"/>
                    <v-divider></v-divider>
                    <v-card flat tile class="comment-form">
                        <v-card-text>
                            <v-form ref="commentform">
                                <!--<v-chip
                                v-if="comment.parent"
                                class="mb-3"
                                close
                                @click:close="comment.parent = null"
                                small
                                >
                                    Replying to: {{ activeComment | truncate(20, '...') }}
                                </v-chip>-->
                                <tiptap-vuetify
                                    class="mt-4"
                                    v-model="comment.comment"
                                    :extensions="extensions"
                                    placeholder=""
                                />
                                <v-checkbox
                                    v-model="comment.public"
                                    v-if="comment.parent == null"
                                    label="Make Public & Notify Customer"
                                    hide-details
                                    class="mt-1 public"
                                    ripple="false"
                                ></v-checkbox>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions class="admin-action">
                            <v-spacer></v-spacer>
                            <v-btn large text tile elevation="0" @click="sendComment" :loading="loading">Submit</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions> 
                    </v-card>
                  </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="title justify-center">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn large min-width="100%" color="primary" tile @click="editItem(item)">      
        <v-icon
        >
          mdi-pencil
        </v-icon>
      </v-btn>             
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
    <template v-slot:item.assignee="{ item }">
      <span>{{ item.assignee.name }}</span>
    </template>
    <template v-slot:item.status="{ item }">
      <v-chip
        color="green"
        text-color="white"
        v-if="item.status == 'resolved'"
      >
        Resolved
      </v-chip>
      <v-chip
        color="primary"
        text-color="white"
        v-else-if="item.status == 'pending'"
      >
        Pending
      </v-chip>
      <v-chip
        color="orange"
        text-color="white"
        v-else-if="item.status == 'in_progress'"
      >
        In Progress
      </v-chip>
      <v-chip
        color="red"
        text-color="white"
        v-else-if="item.status == 'cancelled'"
      >
        Cancelled
      </v-chip>
    </template>
  </v-data-table>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Comment from '../Comment.vue'
    import { TiptapVuetify, Link, Image } from 'tiptap-vuetify'

    export default {
        data: () => ({
            dialog: false,
            dialogDelete: false,
            // declare extensions you want to use
            extensions: [
                Link,
                Image,
            ],
            headers: [
                {
                  text: 'Issue',
                  align: 'start',
                  sortable: false,
                  value: 'issue',
                },
                { text: 'Status', value: 'status', sortable: false },
                { text: 'Deadline', value: 'deadline', sortable: false },
                { text: 'Assignee', value: 'assignee', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            issues: [],
            editedIndex: -1,
            editedItem: {
                issue: '',
                status: 'pending',
                deadline: new Date().toISOString().substr(0, 10),
                assignee: '',
                comment: '',
            },
            defaultItem: {
                issue: '',
                status: 'pending',
                deadline: new Date().toISOString().substr(0, 10),
                assignee: '',
                comment: '',
            },
            statuses: [
                { label: 'Resolved', value: 'resolved' },
                { label: 'In Progress', value: 'in_progress' },
                { label: 'Pending', value: 'pending' },
                { label: 'Cancelled', value: 'cancelled' },
            ],
            tabjob: null,
            comment: {
                comment: '',
                public: false,
                parent: null,
                type: 'comment'
            },
        }),

        computed: {
            ...mapGetters({
                users: 'data/users',
            }),
            formTitle () {
                return this.editedIndex === -1 ? 'New Issue' : 'Edit Issue'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        created () {
            this.initialize()
        },

        components: {
          Comment,
          TiptapVuetify,
        },

        methods: {
            initialize () {
                this.issues = [
                    {
                        issue: 'Test 2',
                        status: 'pending',
                        deadline: new Date().toISOString().substr(0, 10),
                        assignee: {"id":2,"name":"Jeremy Flatt"},
                        note: 'Test Comment',
                        comments: [
                          {"id":1010,"comment":"<p>test</p>","created_at":"January 7th 2021, 07:41 PM","user":"Pramitha Gayan(Mr. Pool)","user_type":"E","email":"pramithagayan@gmail.com","public":false,"children":[]}
                        ],
                        comment: {
                            comment: '',
                            public: false,
                            parent: null,
                            type: 'comment'
                        },
                    },
                    {
                        issue: 'Test 1',
                        status: 'in_progress',
                        deadline: new Date().toISOString().substr(0, 10),
                        assignee: {"id":2,"name":"Jeremy Flatt"},
                        note: 'Test',
                        comments: [],
                        comment: {
                            comment: '',
                            public: false,
                            parent: null,
                            type: 'comment'
                        },
                    },
                ]
            },

            editItem (item) {
                this.editedIndex = this.issues.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = this.issues.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.issues.splice(this.editedIndex, 1)
                this.closeDelete()
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            save () {
                if (this.editedIndex > -1) {
                Object.assign(this.issues[this.editedIndex], this.editedItem)
                } else {
                this.issues.push(this.editedItem)
                }
                this.close()
            },

            async sendComment() {
                this.loading = true
                this.addComment({
                    id: this.id, 
                    comment: this.comment.comment, 
                    public: this.comment.public, 
                    parent: this.comment.parent,
                    type: this.comment.type
                }).then(response => {
                    this.loading = false
                    if(response.parent) {
                        let filteredComment = this.form.comments.filter(comment => {
                            return comment.id == response.parent
                        })

                        filteredComment[0].children.unshift(response)
                    } else {
                        this.form.comments.unshift(response)
                    }
                    this.comment.comment = ''
                    this.comment.public = false
                    this.comment.parent = null
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved')
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save your comment! Please try again.')
                })
            },
            replyComment(parent, type) {
                this.comment.parent = parent
                this.comment.type = type
                const el = this.$el.getElementsByClassName('comment-form')[0]

                if (el) {
                    el.scrollIntoView({behavior: 'smooth'})                
                    this.$nextTick(() => this.$refs.comment.$refs.input.focus())
                }
            },
        },
    }
</script>
<style lang="sass">
.v-data-table
  &.issues
    .v-data-table__mobile-table-row 
        td
            &:last-child 
                background: #003a6f
                padding: 5px

                .v-data-table__mobile-row__header
                    display: none

                .v-data-table__mobile-row__cell
                        width: 100%
                        color: #fff
</style>